import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MaxPointsRewardCalculationTypeEditor() {
    const { t } = useTranslation();

    return <Stack>
        <Typography variant="caption">{t("actionModules.rewardCalculationType.maxPoints.description")}</Typography>
    </Stack>
}